module.exports = __webpack_public_path__ + "static/media/logo-blue.95cc12e8.svg";